import { listSocialLinks, SOCIAL_NETWORK_LABELS } from "@loot-os/api-contract";
import { SocialIcon } from "@loot-os/ui/components/social-icon";

import { socialLinksOf } from "../lib/socialLinks.js";
import { useTenant } from "../lib/tenant.js";

/**
 * The footer's row of social icons, one link per network the tenant has set, in the order boxed's
 * footer shows them. Renders nothing for a store with none, so the footer keeps its shape. Each
 * link opens in a new tab and is named for assistive tech by the network, the icon being
 * decorative.
 */
export function SocialLinks() {
  const { config } = useTenant();
  const links = listSocialLinks(socialLinksOf(config));
  if (links.length === 0) return null;

  return (
    // Each link is 24px around a 16px glyph, so the glyphs sit 8px apart and the negative margin
    // puts the first one on the column's left edge.
    <nav aria-label="Social links" className="-ml-1 flex items-center">
      {links.map(({ network, url }) => (
        <a
          key={network}
          href={url}
          aria-label={SOCIAL_NETWORK_LABELS[network]}
          title={SOCIAL_NETWORK_LABELS[network]}
          target="_blank"
          rel="noopener noreferrer"
          className="flex size-6 items-center justify-center rounded-sm text-foreground transition-colors hover:text-muted-foreground"
        >
          <SocialIcon network={network} className="size-4" />
        </a>
      ))}
    </nav>
  );
}
